export { FormControl as default } from '@material-ui/core';
